import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "./Spinner";
import { SERVER_BASE_URL } from "../config";

function WorkerEventLayout({ children }) {
  const { id } = useParams();
  const navigate = useNavigate();

  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let abort = false;
    async function fetchEvent() {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${SERVER_BASE_URL}/api/events/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch event");
        const data = await res.json();
        if (!abort) setEvent(data);
      } catch (e) {
        console.error(e);
        if (!abort) {
          setError("Could not load event details");
          toast.error("Could not load event details");
        }
      } finally {
        if (!abort) setLoading(false);
      }
    }
    fetchEvent();
    return () => {
      abort = true;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (error || !event) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-6 rounded-lg shadow-md text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            {error ? "Error Loading Event" : "Event Not Found"}
          </h2>
          <p className="text-gray-700 mb-4">
            {error || "This event does not exist or has been removed."}
          </p>
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  const formattedDate = event.start_time
    ? new Date(event.start_time).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";

  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      <div className="container mx-auto max-w-5xl px-3 sm:px-4">
        {/* Компактный хедер для воркера */}
        <div className="bg-white rounded-lg shadow-md px-3 py-3 sm:px-4 sm:py-4 mb-0">
          <div className="flex items-center justify-between gap-3">
            <h1 className="text-lg sm:text-xl font-semibold truncate">
              {event.name}
            </h1>
            {formattedDate && (
              <div className="text-gray-600 text-sm sm:text-base whitespace-nowrap">
                {formattedDate}
              </div>
            )}
          </div>
        </div>

        {/* Контент страницы — минимальные отступы, чтобы не было «пустоты» */}
        <div className="mb-4">{children}</div>
      </div>
    </div>
  );
}

WorkerEventLayout.propTypes = {
  children: PropTypes.node,
};

export default WorkerEventLayout;
